import { css, useTheme } from "@emotion/react";
import React, { HTMLAttributes, useEffect, useState } from "react";
import { MainLogoWhite, MainLogoPrimary } from "./main-logo";
import { useScrollPosition } from "@/hooks/use-scroll-position";
import { useMedia } from "use-media";
import { Navi, DrawerNavi } from "./navi";
import { Link } from "gatsby";

export interface HeaderProps extends HTMLAttributes<HTMLElement> {}

export function Header(props: HeaderProps) {
  const [isSticky, setIsSticky] = useState(false);
  const scrollPos = useScrollPosition();
  const theme = useTheme();
  const mq = useMedia(theme.breakpoints.md);

  useEffect(() => {
    if (scrollPos > 100) {
      setIsSticky(true);
    } else if (scrollPos < 50) {
      setIsSticky(false);
    }
  }, [scrollPos, setIsSticky]);

  return (
    <header
      {...props}
      css={(theme) => [
        css`
          position: sticky;
          top: 0;
          width: 100%;
          height: 14.4rem;
          z-index: 10;
          color: ${theme.colors.white};
          background: ${theme.colors.white};
          transition: height 0.5s;

          &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: transparent
              linear-gradient(90deg, #003686 0%, #0068b7 52%, #6fba2c 100%) 0%
              0% no-repeat padding-box;
            opacity: 1;
            transition: opacity 1s;
          }

          @media ${theme.breakpoints.md} {
            height: 19.6rem;
          }
        `,
        isSticky &&
          css`
            height: 12rem;
            color: ${theme.colors.black};

            &::after {
              opacity: 0;
            }

            @media ${theme.breakpoints.md} {
              height: 15.6rem;
            }
          `,
      ]}
    >
      <Link
        to="/"
        css={(theme) => css`
          position: absolute;
          left: 3.6rem;
          top: 50%;
          z-index: 1;
          transform: translateY(-50%);

          @media ${theme.breakpoints.md} {
            left: 6rem;
          }
        `}
      >
        <MainLogoWhite
          css={[
            (theme) => css`
              width: 31rem;
              height: fit-content;
              opacity: 1;
              transition: opacity 0.4s;

              @media ${theme.breakpoints.md} {
                width: 40rem;
              }

              path,
              rect {
                fill: ${theme.colors.white};
              }
            `,
            isSticky &&
              css`
                opacity: 0;
              `,
          ]}
        />

        <MainLogoPrimary
          css={[
            (theme) => css`
              position: absolute;
              left: 0;
              top: 0;
              opacity: 0;
              width: 31rem;
              height: fit-content;
              transition: opacity 0.4s;

              @media ${theme.breakpoints.md} {
                width: 40rem;
              }
            `,
            isSticky &&
              css`
                opacity: 1;
              `,
          ]}
        />
      </Link>

      {mq ? (
        <Navi
          isSticky={isSticky}
          css={css`
            position: absolute;
            top: 50%;
            right: 6rem;
            z-index: 1;
            transform: translateY(-50%);
            transition: color 0.5s;
          `}
        />
      ) : (
        <DrawerNavi
          css={css`
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
            height: 100%;
          `}
        />
      )}
    </header>
  );
}
